import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {EntityPillSelectWrapperSmall} from 'shells/entity-pill/entity-pill-select-wrapper-small';
import {LeadTwoLine} from 'shells/lead/lead-two-line';
import {MiniListPopover} from 'shells/mini-list-popover/mini-list-popover';
import type {Item} from 'shells/mini-list-popover/types';

import type {EmailableLead} from 'nutshell-graphql-types';

import styles from './related-leads-field.module.css';

type Props = FieldProps & {
    relatedLeads: EmailableLead[];
    relatedEntityName: string;
};

export function RelatedLeadsField(props: Props) {
    const {input} = props;
    const {onChange} = input;

    const [selectedLeads, setSelectedLeads] = React.useState<string[]>(props.input.value);
    const [isPopoverShowing, setIsPopoverShowing] = React.useState<boolean>(false);
    const containerRef = React.useRef();

    React.useEffect(() => {
        onChange(selectedLeads);
    }, [selectedLeads, onChange]);

    const handleOpenPopover = () => {
        setIsPopoverShowing(true);
    };

    const handleClosePopover = () => {
        setIsPopoverShowing(false);
    };

    const handleUnselectLead = (id: string) => {
        setSelectedLeads(selectedLeads.filter((lead) => lead !== id));
    };

    const handleToggleCheckbox = (id: string) => {
        if (selectedLeads.includes(id)) {
            handleUnselectLead(id);
        } else {
            setSelectedLeads(selectedLeads.concat(id));
        }
    };

    // @ts-expect-error
    const displayedLeads = props.relatedLeads.filter((relatedLead) =>
        selectedLeads.find((selectedLead) => selectedLead === relatedLead.id)
    );

    return (
        // @ts-expect-error
        <div ref={containerRef}>
            <div onClick={handleOpenPopover} className={styles.container}>
                <div className={styles.label}>Related leads</div>
                <div className={styles.pills}>
                    {/* @ts-expect-error */}
                    {displayedLeads.map((lead) => (
                        <EntityPillSelectWrapperSmall
                            key={lead.id}
                            type='light'
                            value={{
                                id: lead.id,
                                name: `${lead.name}${lead.number ? ` (${lead.number})` : ''}`,
                            }}
                            onRemove={(option: {id: string}) => {
                                handleUnselectLead(option.id);
                            }}
                        />
                    ))}
                </div>
            </div>
            {isPopoverShowing ? (
                <MiniListPopover
                    anchor={containerRef}
                    // @ts-expect-error
                    collection={props.relatedLeads.map((relatedLead) => ({
                        ...relatedLead,
                        isChecked: selectedLeads.includes(relatedLead.id),
                    }))}
                    renderRow={(lead: Item) => (
                        <LeadTwoLine
                            leadName={lead.name}
                            isLinkable={true}
                            disableRouting={true} // routing doesn't work from the composer modal
                            newTab={true}
                            leadNumber={lead.number}
                            avatarUrl={lead.avatarUrl}
                            htmlUrl={lead.htmlUrl}
                            relatedPerson={{
                                id: '',
                                name: props.relatedEntityName,
                                htmlUrl: '',
                                // @ts-expect-error
                                type: '',
                            }}
                            leadStatus={lead.status}
                            priority={lead.priority}
                            withLessPadding={true}
                        />
                    )}
                    onSelect={handleToggleCheckbox}
                    onClose={handleClosePopover}
                    location='bottom'
                />
            ) : undefined}
        </div>
    );
}
